import { createAsyncThunk } from "@reduxjs/toolkit";
import { api, generateConfig } from "../../utils/apiConfig";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";

export const fetchAiNlpPropertiesThunk = createAsyncThunk(
  "aiNlp/fetchProperties",
  async ({ prompt, location }, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const { token } = state.auth;
      const config = generateConfig(token);

      // Ensure we have a session ID
      let sessionId = state.aiNlp.sessionId;
      if (!sessionId) {
        sessionId = uuidv4();
      }

      // Get user ID from auth state
      const userId = state.auth.user?._id;
      if (!userId) {
        return rejectWithValue(
          "User ID not found. Please ensure you are logged in."
        );
      }

      const response = await api.post(
        "/v1/api/ai-nlp",
        {
          prompt,
          sessionId,
          userId,
          location,
        },
        config
      );

      return response.data;
    } catch (error) {
      console.error("Error in fetchAiNlpPropertiesThunk:", error);
      return rejectWithValue(
        error.response?.data || "Failed to process property search"
      );
    }
  }
);

export const fetchChatHistoryThunk = createAsyncThunk(
  "aiNlp/fetchChatHistory",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const { token } = state.auth;
      const config = generateConfig(token);

      // Get user ID from auth state
      const userId = state.auth.user?._id;
      if (!userId) {
        return rejectWithValue(
          "User ID not found. Please ensure you are logged in."
        );
      }

      const response = await api.get(
        "/v1/api/ai-nlp/chat-history",
        config
      );

      return response.data;
    } catch (error) {
      console.error("Error in fetchChatHistoryThunk:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch chat history"
      );
    }
  }
);

export const loadChatSessionThunk = createAsyncThunk(
  "aiNlp/loadChatSession",
  async (sessionId, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const { token } = state.auth;
      const config = generateConfig(token);

      // Get user ID from auth state
      const userId = state.auth.user?._id;
      if (!userId) {
        return rejectWithValue(
          "User ID not found. Please ensure you are logged in."
        );
      }

      const response = await api.get(
        `/v1/api/ai-nlp/chat-session/${sessionId}`,
        config
      );

      return response.data;
    } catch (error) {
      console.error("Error in loadChatSessionThunk:", error);
      return rejectWithValue(
        error.response?.data || "Failed to load chat session"
      );
    }
  }
);

export const endChatSessionThunk = createAsyncThunk(
  "aiNlp/endSession",
  async (sessionId, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const { token } = state.auth;
      const config = generateConfig(token);

      // Get user ID from auth state
      const userId = state.auth.user?._id;
      if (!userId) {
        return rejectWithValue(
          "User ID not found. Please ensure you are logged in."
        );
      }

      const response = await api.post(
        "/v1/api/ai-nlp/end-session",
        {
          sessionId,
          userId,
        },
        config
      );

      return response.data;
    } catch (error) {
      console.error("Error in endChatSessionThunk:", error);
      return rejectWithValue(
        error.response?.data || "Failed to end chat session"
      );
    }
  }
);
